import { render } from "./SkyCalendar.vue?vue&type=template&id=4bfa2d0b"
import script from "./SkyCalendar.vue?vue&type=script&lang=js"
export * from "./SkyCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__